import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { findOptionTags, replaceOptionTags } from 'utils/vnode';

import Button from 'components/button/button';

import s from 'components/inlineSelect/inlineSelect.sss';

export default class InlineSelect extends Component {
	constructor(props) {
		super(props);

		let value = this.sanitizeValue(props.value ?? props.initialValue);
		this.state = {
			value,
		};

		this.onSelectionChanged = this.onSelectionChanged.bind(this);
		this.renderOption = this.renderOption.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const options = this.getOptions(nextProps);
		let nextValue = this.sanitizeValue(nextProps.value !== this.props.value ? nextProps.value : this.state.value, options, nextProps.defaultValue);
		if (nextValue !== this.state.value) {
			this.setState({ value: nextValue });
		}
	}

	get value() {
		return this.state.value;
	}
	set value(v) {
		let nextValue = this.sanitizeValue(v);
		if (nextValue !== this.state.value) {
			this.setState({ value: nextValue });
		}
	}

	get details() {
		return this.props.details;
	}

	sanitizeValue(value, options = this.getOptions(), defaultValue = this.props.defaultValue) {
		if (options.includes(value)) return value;
		if (defaultValue && options.includes(defaultValue)) return defaultValue;
		return options[0];
	}

	getOptions(props = this.props) {
		return findOptionTags(props.children).map(option => option.attributes.value);
	}

	triggerChange() {
		this.props.onChange?.({ target: this });
	}

	setValue(value) {
		if (value === this.state.value) {
			return;
		}
		this.setState({ value });
		this.triggerChange();
	}

	onSelectionChanged(e) {
		this.setValue(e.target.value);
	}

	renderOption(element) {
		return (
			<Button
				tag="label"
				icon={element.attributes.icon}
				iconSize="small"
				class={joinClasses(s.option, element.attributes.class)}
				dark={this.props.dark}
			>
				<input
					type="radio"
					name={this.props.name}
					value={element.attributes.value}
					checked={element.attributes.value === this.state.value}
					onChange={this.onSelectionChanged}
					disabled={this.props.disabled || element.attributes.disabled}
				/>
				<div class={s.content}>
					{element.children}
				</div>
			</Button>
		);
	}

	render(props) {
		return (
			<div
				class={joinClasses(s.wrapper, props.dark && s.dark, props.transparent && s.transparent, props.small && s.small, props.vertical && s.vertical, props.fullWidth && s.fullWidth, props.class)}
				data-value={this.state.value}
			>
				{replaceOptionTags(props.children, this.renderOption)}
			</div>
		);
	}

}